<div class="container-md">
  <div class="form-group">
    <!-- Title -->
    <h4 class="sign-in-dialog-centered my-4">
      {{ 'IDS_WELCOME_TO_MEMORABID' | translate }}
    </h4>

    <!-- Existing user prompt -->
    <div class="d-flex justify-content-center">
      <div class="sign-in-dialog-centered text-muted">
        {{ 'IDS_ALREADY_HAVE_ACCOUNT' | translate }}
      </div>
    </div>
    <!-- Login button (first, centered) -->
    <div class="d-flex justify-content-center mt-3">
      <button 
        type="button" 
        class="btn-gold fw-bold px-3 text-uppercase"
        (click)="goToLogin()"
      >
        {{ 'IDS_LOGIN' | translate }}
      </button>
    </div>

    <!-- Divider -->
    <div class="welcome-divider my-4">
      <span>{{ 'IDS_OR' | translate }}</span>
    </div>

    <!-- New user prompt -->
    <div class="d-flex justify-content-center">
      <div class="sign-in-dialog-centered text-muted">
        {{ 'IDS_NEW_TO_MEMORABID' | translate }}
      </div>
    </div>
    <!-- Register button (second, centered) -->
    <div class="d-flex justify-content-center mt-3">
      <button 
        type="button" 
        class="btn-gold fw-bold px-3 text-uppercase"
        (click)="goToRegister()"
      >
        {{ 'IDS_REGISTER' | translate }}
      </button>
    </div>
  </div>
</div>
